import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import c from '../../../components/commonStyle.css';
import rdp from '!isomorphic-style-loader!css-loader!sass-loader!react-day-picker/lib/style.css';
import s from '!isomorphic-style-loader!css-loader!sass-loader!./MonthPassRange.css';

import cx from 'classnames';

import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

// Redux
import { connect } from 'react-redux';

// Redux Action
//import { checkAvailability } from '../../../actions/checkAvailability';

// Redux Form
import { change, formValueSelector } from 'redux-form';

import { CHECK_AVAILABLE_DATES_SUCCESS } from '../../../constants';

// Translation
import { injectIntl } from 'react-intl';

// Locale
//import messages from '../../../locale/messages';

//Helper
//import { isRTL } from '../../../helpers/formatLocale';
//import { getDateUsingTimeZone } from '../../../helpers/dateRange';
//import { dateFormat } from '../../../config';

class MonthPassRange extends React.Component {
  static propTypes = {
    /* checkAvailability: PropTypes.any.isRequired, */
    blockedDates: PropTypes.array.isRequired,
    listId: PropTypes.number.isRequired,
    formName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
    country: PropTypes.string.isRequired,
    guests: PropTypes.number
  };

  static defaultProps = {
    blockedDates: [],
    country: ''
  }

  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      disabledDays: [],
      hoverRange: undefined,
      selectedDays: []
    };

    //this.handleMonthPassDayClick = this.handleMonthPassDayClick.bind(this);
    this.handleAsyncOperations = this.handleAsyncOperations.bind(this);
  }

  /* //#region checkingBlockedDates
  componentDidMount() {
    const { guests, maxCapacity, bookingStartDate, bookingEndDate, blockedDates, handleDatesChange } = this.props;

    this.updateCalendar(guests, maxCapacity, bookingStartDate, bookingEndDate, blockedDates, handleDatesChange);
  }

  componentWillReceiveProps(nextProps) {
    const { guests, maxCapacity, bookingStartDate, bookingEndDate, blockedDates, handleDatesChange } = nextProps;
    
    this.updateCalendar(guests, maxCapacity, bookingStartDate, bookingEndDate, blockedDates, handleDatesChange);
  }

  updateCalendar = (guests, maxCapacity, bookingStartDate, bookingEndDate, blockedDates, handleDatesChange) => {
    this.setState({
      startDate: moment(bookingStartDate),
      endDate: moment(bookingEndDate)
    });
    
    let disabledDays = [];
    let currentDate;
    let currentMaxCapacity = maxCapacity;
    blockedDates.forEach(day => {
      currentDate = new Date(day.blockedDates);
      if( day.isHotDesking ) {
        if( day.remainingCapacity < guests ) {
          disabledDays.add(new Date(currentDate));
        }
        if (bookingStartDate && bookingEndDate && day.blockedDates >= moment(bookingStartDate).format('YYYY-MM-DD') && day.blockedDates <= moment(bookingEndDate).format('YYYY-MM-DD') ) {
          currentMaxCapacity = Math.min(currentMaxCapacity, day.remainingCapacity);
        }
      }
      else if (day.calendarStatus != 'available') {
        disabledDays.add(new Date(currentDate));
      }
    });

    this.setState({disabledDays});

    handleDatesChange(currentMaxCapacity);
  }
  //#regionend
  */

  getSelectedDays = (monthPassRange) => {
    const { isOpenOnWeekends } = this.props;
    
    let currentDay = new Date(monthPassRange.from);
    const days = [];
    while( currentDay <= monthPassRange.to ) {
      if( isOpenOnWeekends || ![0,6].includes(currentDay.getDay()) ) {
        days.push(new Date(currentDay));
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
    return days;
  }

  getMonthPassRange = startDate => {
    const { isOpenOnWeekends } = this.props;
    
    let startDateDayInMonth = moment(startDate).date();
    let daysInStartMonth = moment(startDate).daysInMonth();
    let firstOfEndMonth = moment(startDate).add(daysInStartMonth-startDateDayInMonth+1, 'days');
    let daysInEndMonth = firstOfEndMonth.daysInMonth();

    let endDate = startDateDayInMonth < daysInEndMonth ? firstOfEndMonth.add(startDateDayInMonth-1, 'days').toDate() : firstOfEndMonth.add(daysInEndMonth-1, 'days').toDate();

    while( !isOpenOnWeekends && [0,6].includes(endDate.getDay()) ) {
      endDate.setDate(endDate.getDate() + ( startDateDayInMonth < daysInEndMonth ? 1 : -1 ));
    }

    return {
      from: startDate,
      to: endDate,
    };
  }

  //handleMonthPassDayClick(date, modifiers = {}) {
  handleMonthPassDayClick = /* async */ (date, modifiers = {}) => {
    if( modifiers.disabled ) {
      return;
    }

    /* //#region other_endDate_handling
    let startMonth = moment(startDate).month();
    let endMonth = startMonth == 12 ? 1 : startMonth+1;
    let endDate = moment(date).add(1, 'month').toDate();
    //#endregion
    */

    /* //#region moved_to_getMonthPassRange
    let startDateDayInMonth = moment(startDate).day();
    let daysInStartMonth = moment(startDate).daysInMonth();
    let firstOfEndMonth = moment(startDate).add(daysInStartMonth-startDateDayInMonth+1, 'days');
    let daysInEndMonth = firstOfEndMonth.daysInMonth();

    let endDate = startDateDayInMonth < daysInEndMonth ? firstOfEndMonth.add(startDateDayInMonth-1, 'days').toDate() : firstOfEndMonth.add(daysInEndMonth-1, 'days').toDate();
    //#endregion
    */

    let startDate = moment(date);
    let monthPassRange = this.getMonthPassRange(date);
    let endDate = moment(monthPassRange.to);
    
    this.setState({
      selectedDays: this.getSelectedDays(monthPassRange),
      startDate,
      endDate
    });

    this.handleAsyncOperations(startDate, endDate);
  }

  /* handleAsyncOperations = async (startDate, endDate) => { */
  async handleAsyncOperations(startDate, endDate) {
    const { formName, change, dispatch } = this.props;
    /* const { listId, isOpenOnWeekends, guests, checkAvailability } = this.props; */
    
    await change(formName, 'startDate', startDate);
    await change(formName, 'endDate', endDate);
    /* await checkAvailability(listId, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'), 0, -1, isOpenOnWeekends, guests); */

    await dispatch({
      type: CHECK_AVAILABLE_DATES_SUCCESS,
      isLoading: false,
      availability: true,
      payload: {
        maximumStay: false,
        minimumStay: false,
        closedOnWeekends: false
      }
    });
  }

  handleDayEnter = date => {
    this.setState({
      hoverRange: this.getMonthPassRange(date)
    });
  };

  handleDayLeave = () => {
    this.setState({
      hoverRange: undefined
    });
  };

  render() {
    //const { startDate, endDate } = this.state;
    const { isOpenOnWeekends, locale, smallDevice } = this.props;
    //const { formatMessage } = this.props.intl;
    const { /* guests, */ disabledDays, hoverRange, selectedDays } = this.state;

    //Move to componentDidMount()?
    let monthPassDaysAreSelected = selectedDays.length > 0;
    let placeholderDate = new Date();
    while( !isOpenOnWeekends ) {
      if( ![0,6].includes(placeholderDate.getDay())) {
        break;
      }
      placeholderDate.setDate(placeholderDate.getDate() + 1);
    }
    let placeholder = formatDate(placeholderDate, 'L', locale);
    //

    return (
      <div className={'SelectedMonth'}>
        <DayPickerInput
          /* classNames={{container: 'input__SelectedMonth',
                       overlay: 'DayPicker-Overlay'}} */
          component={props => <input className={cx(c.commonControlInput, c.fullWidth)} {...props} />}
          formatDate={formatDate}
          parseDate={parseDate}
          format={'L'}
          placeholder={placeholder}
          /* showOverlay={true} */
          dayPickerProps={{
            numberOfMonths: smallDevice ? 1 : 2,
            firstDayOfWeek: 1,
            locale: locale,
            localeUtils: MomentLocaleUtils,
            selectedDays: selectedDays,
            showOutsideDays: true,
            onDayClick: this.handleMonthPassDayClick,
            onDayMouseEnter: this.handleDayEnter,
            onDayMouseLeave: this.handleDayLeave,
            disabledDays: [DateUtils.isPastDay, ...disabledDays, ...!isOpenOnWeekends ? [{daysOfWeek: [0, 6]}] : []],
            modifiers: {
              hoverRange,
              selectedRange: monthPassDaysAreSelected && {
                from: selectedDays[0],
                to: selectedDays[selectedDays.length-1],
              },
              hoverRangeStart: hoverRange && hoverRange.from,
              hoverRangeEnd: hoverRange && hoverRange.to,
              selectedRangeStart: monthPassDaysAreSelected && selectedDays[0],
              selectedRangeEnd: monthPassDaysAreSelected && selectedDays[selectedDays.length-1],
            }}}
        />
      </div>
    );
    
    //#region DayPicker_component
    /* return (
      <DayPicker
          numberOfMonths={1}
          firstDayOfWeek={1}
          selectedDays={selectedDays}
          onDayClick={this.handleMonthPassDayClick}
          disabledDays={[DateUtils.isPastDay, ...disabledDays, ...!isOpenOnWeekends ? [{daysOfWeek: [0, 6]}] : []]}
          modifiers={{
            hoverRange,
            selectedRange: monthPassDaysAreSelected && {
              from: selectedDays[0],
              to: selectedDays[selectedDays.length-1],
            },
            hoverRangeStart: hoverRange && hoverRange.from,
            hoverRangeEnd: hoverRange && hoverRange.to,
            selectedRangeStart: monthPassDaysAreSelected && selectedDays[0],
            selectedRangeEnd: monthPassDaysAreSelected && selectedDays[selectedDays.length-1],
          }}
        />
    ); */
    //#endregion
  }
}

const bookingFormSelector = formValueSelector('BookingForm');

const mapState = state => ({
  bookingStartDate: bookingFormSelector(state, 'startDate'),
  bookingEndDate: bookingFormSelector(state, 'endDate'),
  locale: state.intl.locale,
  guests: bookingFormSelector(state, 'guests')
});

const mapDispatch = {
  /* checkAvailability, */
  change
};

export default injectIntl(withStyles(c, s, rdp)(connect(mapState, mapDispatch)(MonthPassRange)));



// WEBPACK FOOTER //
// src/components/ViewListing/MonthPassRange/MonthPassRange.js